import { render, staticRenderFns } from "./CashNotAccount.vue?vue&type=template&id=b084c400&scoped=true&"
import script from "./CashNotAccount.vue?vue&type=script&lang=js&"
export * from "./CashNotAccount.vue?vue&type=script&lang=js&"
import style0 from "./CashNotAccount.vue?vue&type=style&index=0&id=b084c400&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b084c400",
  null
  
)

export default component.exports